import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core'
import { Router } from '@angular/router';
import {Location} from '@angular/common';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Constants } from 'app/shared/constant/constants';
import { CardService } from 'app/modules/card/services/card.service';
import { ExplorerCardActivationRequest, ExplorerCardIssuanceRequest } from '../../modal/ExplorerCardActivation';
import { UpdateProfileService } from 'app/modules/update-profile/services/update-profile.service';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import { ToastrService } from 'ngx-toastr';
import { DateUtils } from 'app/shared/utility/date-utils';
import moment from 'moment';
import { UpdateProfileModel } from 'app/modules/update-profile/models/update-profile.model';
import { InputPatterns } from 'app/shared/helper/input-patterns';
import { AddAddressModel } from 'app/modules/address/models/address.model';
import { AddressService } from 'app/modules/address/services/address.service';


@Component({
  selector: 'xplorer-card-activation-form',
  templateUrl: './xplorer-card-activation-form.component.html',
  styleUrls: ['./xplorer-card-activation-form.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class XplorerCardActivationFormComponent implements OnInit {


  showLoader: boolean = false;
  currentStep = 1;
  steps = [1, 2, 3];

  public fullName;
  public email;
  public mobileNumber;
  public profession;
  public companyName;
  public designation;
  public passportIssueDate: any;
  public passportExpiryDate: any;
  public platform;
  public userName;

  // Define form groups for each step
  formStep1!: FormGroup;
  formStep2!: FormGroup;
  formStep3!: FormGroup;
  formStep4!: FormGroup;
  public formData: FormData = new FormData();
  issuanceForm: FormGroup;
  
  public filePassportFront: File;
  public filePassportBack: File;
  public panCardFile: File;
  public xplorerRegData: any;

  public isPanUploaded: boolean = false;
  public isPassportFrontUpload: boolean = false;
  public isPassportBackUpload: boolean = false;

  public modalReference: any;  
  public profilePan = "";
  @ViewChild("cardActivationSuccess") cardActivationSuccess: TemplateRef<any>;  
  @ViewChild("vcipModalNewUser") vcipModalNewUser: TemplateRef<any>;  
  @ViewChild("PANDetailModal") PANDetailModal: TemplateRef<any>;
  @ViewChild("errorModal") errorModal: TemplateRef<any>;
  @ViewChild("xplorerWelcomeModal") xplorerWelcomeModal: TemplateRef<any>;

  
  public explorerActivationRequest = new ExplorerCardActivationRequest();
  public explorerCardIssuanceRequest = new ExplorerCardIssuanceRequest();  
  public nextButtonText: string = "Next";
  

  public consumerDetail: any;
  public paxId;
  public resGetVcipStatus: any;  
  public vcipStatus;

  public passportFrontSideLink;
  public passportBackSideLink;
  public panCardLink;

  public updateProfileModel = new UpdateProfileModel();
  isPANCBChecked: boolean = false;
  public panVerificationErrMsg: any;
  public addressPattern = InputPatterns.ADDRESS_PATTERN;
  public addressPatternOnInput = InputPatterns.ADDRESS_PATTERN_ONINPUT;  

  dobMaxDate: any;
  public showAddAddressForm: boolean = false;
  
  public cityItemList: any = [];
  public addAddressModel = new AddAddressModel();
  public addressTypeList = Constants.locationTypeList;  

  public isPincodeIsValid = false;
  public isPincodeCheck = false;
  public deliveryStatus;
  public isDeliveryStatusCheck = false;
  public isXplorerChecked: boolean = false;

  private cards = Constants.cardData;  
  public isNewCustomer: boolean = false;
  public consumerAddressList: any = [];
  public addressActionBtnText:string  = 'Add';
  public addressIdForUpdate: string = "";
  public customerMoblieNo: string;
  public custoemrEmailid: string;
  public newAddressId: string;
  public formSubmissionAddressId: string = "";
  public consumerExistSubTerms: boolean = false;

  constructor(private fb: FormBuilder,
    private modalService: NgbModal,
    private cardService: CardService,
    private updateProfileService: UpdateProfileService,
    public toast: ToastrService,
    public addressService : AddressService,
    public router: Router,) {

    this.dobMaxDate = {
      year: new Date().getFullYear() - 13,
      month: new Date().getMonth() + 1,
      day: new Date().getDate(),
    };

    }

  ngOnInit(): void {
    this.addAddressModel.isDefault=false;

    setTimeout(() => {
      this.modalReference = this.modalService.open(this.xplorerWelcomeModal, {centered: true,size: "md", backdrop: 'static', keyboard: false,  windowClass: 'xplorer-wel-modal'});
    }, 500);


    this.getProfileList();
    this.getVCIPStatus();

    this.getXplorerUserAddress();
    this.getConsumerDetails();

    setTimeout(() => {
      this.modalReference?.close();
    }, 3000);

    let registrationData = localStorage.getItem(ConstantsKey.XPLORER_CARD_DATA);

    if(registrationData) {
       this.xplorerRegData = JSON.parse(registrationData);
      let regData = this.xplorerRegData.explorersRegistrations;
        console.log(" --------------------------------------- ", regData);
        this.explorerActivationRequest.id = regData.id;
        this.explorerActivationRequest.fullName = regData.fullName;
        this.explorerActivationRequest.email = regData.email;     
        this.explorerActivationRequest.preferredName = regData.preferredName;              

        this.mobileNumber = regData.mobile;
        this.profession = regData.profession;
        this.companyName = regData.companyName;
        this.designation = regData.designation;
        this.platform = regData?.platform;
        this.userName = regData?.userName;
    }
  
    // Step 1 form with additional fields and validation
    this.formStep1 = this.fb.group({
      fullName: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
      mobileNumber: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      profession: ['', Validators.required],
      companyName: [''],
      designation: [''],
      platform: [''],
      userName: ['']
    });

    this.issuanceForm = this.fb.group({
      firstName: [''],
      // middleName: ['', Validators.required],
      lastName: [''],      
      mobileNumber: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      dob: ['', Validators.required],
      emailId: ['', Validators.required],
      preferredNameOnCard: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9 ]{1,19}$/)]]
    });

    this.formStep2 = this.fb.group({
      panUpload: [null , Validators.required], 
      dob: ['', Validators.required],
      panNumber: ['', [Validators.required, Validators.pattern('[A-Za-z0-9]{10}')]],
    });    

    // Step 3 form - Passport Details
    this.formStep3 = this.fb.group({
      passportFrontPage: [null, Validators.required],
      passportBackPage: [null, Validators.required],
      passportNumber: ['', Validators.required],
      passportExpiryDate: ['', Validators.required],
      passportIssueDate: ['', Validators.required],
      passportIssuePlace: ['', Validators.required]
    });

    // Step 4 form - Address and Card Details
    this.formStep4 = this.fb.group({
      preferredNameOnCard: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9 ]{1,19}$/)]],
      address: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      pincode: ['', [Validators.required, Validators.pattern(/^[1-9][0-9]{5}$/)]]
    });

  }

  // Getter for current form based on the step
  get currentForm(): FormGroup {
    switch (this.currentStep) {
      // case 1: return this.formStep1;
      case 1: return this.formStep2;
      case 2: return this.formStep3;
      case 3: return this.formStep4;
      default: return this.formStep2;
    }
  }

  // Handle next step
  nextStep() {

          //this.saveData();

    if (this.currentForm.valid && this.currentStep < this.steps.length) {
        if(this.currentStep > 1) {

        }    
        if(this.currentStep == 2) {
            this.explorerActivationRequest.passportExpiryDate = DateUtils.getNgbDateStructToDate(this.passportExpiryDate);
            this.explorerActivationRequest.passportIssueDate = DateUtils.getNgbDateStructToDate(this.passportIssueDate);
            this.nextButtonText = "SUBMIT";
        }
        this.currentStep++;
    } else {
      this.currentForm.markAllAsTouched();
      if(this.currentForm.valid) {
        if(this.currentStep == 3) {


        this.showLoader = true;

        this.addAddressModel.locationType = "HOME";
        this.addAddressModel.address = this.explorerActivationRequest.deliveryAddress;
        this.addAddressModel.postalCode = this.explorerActivationRequest.pinCode;
        this.addAddressModel.city = this.explorerActivationRequest.city;
        this.addAddressModel.state = this.explorerActivationRequest.state;
        this.addAddressModel.isDefault = true;
        this.addAddressModel.country = 'INDIA';
        

        this.addressService.addXplorerCardAddress(this.addAddressModel).subscribe((resp => {
          this.showLoader = false;
          console.log("Address Save Response : ---- ", resp);
          this.newAddressId = resp.body["id"];
          this.proceedForCardPurchase();

        }),error=>{
          this.showLoader = false;
          this.toast.error(error.error.message);
        });



            // let xplorerRequestObj = {
              
            // };

            // this.cardService.updateXplorerCustomerDetails(xplorerRequestObj).subscribe(resp => {

            // }, err => {

            // });



          console.log("ALL DATA ------------------------", this.explorerActivationRequest);
          // this.saveData();
        }        
      }
    }


  }

  // Handle previous step
  prevStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
      if(this.currentStep <= 3) {
        this.nextButtonText = "Next";
      }
    } else if(this.currentStep == 1) {
      this.router.navigate(["cards"]);
    }
  }

  // Handle navigation to a specific step
  goToStep(step: number) {
    if (step <= this.currentStep) {
      this.currentStep = step;
    }
  }

  // Handle form submission
  submit() {
    if (this.currentForm.valid) {
      alert('Form submitted!');
    } else {
      this.currentForm.markAllAsTouched();
    }
  }



  // Function to convert input to uppercase
  formatPanNumber() {
    const panInput = this.formStep2.get('panNumber');
    if (panInput?.value) {
      panInput.setValue(panInput.value.toUpperCase());
    }
  }

  saveForm() {
    this.modalReference = this.modalService.open(this.cardActivationSuccess, {centered: true,size: "md",});
    //this.modalReference.close();
  }

  saveData() {


      //this.modalReference = this.modalService.open(this.cardActivationSuccess, {centered: true,size: "md",});
    this.showLoader = true;
      this.cardService.explorersActivation(this.explorerActivationRequest).subscribe(res=> {
        this.showLoader = false;
        if(this.currentStep == 2) {
          // this.nextButtonText = "Submit";
        } else if(this.currentStep == 3) {
          if(this.vcipStatus == false) {
            this.modalReference = this.modalService.open(this.vcipModalNewUser, {centered: true,size: "md",});
          } else {          
            this.modalReference = this.modalService.open(this.cardActivationSuccess, {centered: true,size: "md",});
          }
        }
        this.currentStep++; 
      }, err => {
        this.showLoader = false;
        this.toast.error(err.error.message);
      });

  }

  fileUploadPaxDocument(event, fileType) {
    let fileList: FileList = event.target.files;

    if (fileList.length > 0) {
      let file: File = fileList[0];
      let docType: string;

      if (fileType == 'passportFront') {
        // this.filePassportFront = fileList[0];
        docType = "PASSPORT_FRONT_PAGE";
      } else if(fileType == 'passportBack') {
        // this.filePassportBack = fileList[0];
        docType = 'PASSPORT_ADDRESS_PAGE';
      } else if(fileType == 'PANCARD') {
        docType = 'PANCARD';
      }

    if (fileList.length > 0) {
      let file: File = fileList[0];
      if (file.type.indexOf("pdf") >= 0 || file.type.indexOf("image") >= 0) {
        const formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('ownerType', "PAX");
        formData.append('type', docType);
        formData.append('description', "");
        formData.append('ownerId', this.paxId);
        formData.append('documentPurpose', "ADDRESS_PROOF");

          this.updateProfileService.paxDocumentUploadUpdate(formData).subscribe((respDoc) => {
            this.showLoader = false;
            console.log(" DOCUMENT UPLAODED -------------------------------- ",respDoc);
              let respDocs:any = respDoc.body;

              respDocs.forEach(singleDoc => {
                if (singleDoc.type == "PANCARD") {
                  this.panCardLink = respDocs[0].location;                  
                } else if(singleDoc.type == "PASSPORT_FRONT_PAGE") {
                  this.passportFrontSideLink = respDocs[0].location;                  
                } else if(singleDoc.type == "PASSPORT_ADDRESS_PAGE") {
                  this.passportBackSideLink = respDocs[0].location;                  
                }
              });
            
              if (fileType == 'passportFront') {
                this.filePassportFront = fileList[0];
                this.isPassportFrontUpload = true;
                this.formStep3.patchValue({
                  ["passportFrontPage"]: this.filePassportFront
                });
                this.formStep3.get("passportFrontPage")?.updateValueAndValidity();
              } else if(fileType == 'passportBack') {                 
                this.filePassportBack = fileList[0];
                this.isPassportBackUpload = true;
                this.formStep3.patchValue({
                  ["passportBackPage"]: this.filePassportBack
                });
                this.formStep3.get("passportBackPage")?.updateValueAndValidity();
              } else if(fileType == 'PANCARD') {
                this.panCardFile = fileList[0];
                this.isPanUploaded = true;
                this.formStep2.patchValue({
                  ["panUpload"]: this.panCardFile
                });
                this.formStep2.get("panUpload")?.updateValueAndValidity();                
              }

            if(this.filePassportBack && this.filePassportFront && fileType != 'PAN') {
              this.doOcrPassport();
            }
            this.toast.success('Document uploaded successfully!');
          }, (error) => {
            this.showLoader = false;
            this.toast.error(error.error.message);
          });

        this.showLoader = false;
      } else {
        this.showLoader = false;
        this.toast.error('Please select a pdf or image file only');
      }
    } else {
      console.log("Hello I m in error last,", this.showLoader);
      this.showLoader = false;
    }

        /* if (this.filePassportBack && this.filePassportFront) {
          this.doOcrPassport();
        } */

    }

  }

    doOcrPassport() {
    this.showLoader = true;
    this.formData = new FormData();
    this.formData.append('passportFront', this.filePassportFront, this.filePassportFront.name);
    this.formData.append('passportBack', this.filePassportBack, this.filePassportBack.name);

    this.updateProfileService.passportOCR(this.formData).subscribe(result => {
      let response = result.body;
      this.showLoader = false;

      if (response != null && response['response']['result']['passportNumber'] != null &&
        response['response']['result']['passportNumber'].length > 0) {
        this.explorerActivationRequest.passportNumber = response['response']['result']['passportNumber'];
        this.explorerActivationRequest.passportIssuePlace = response['response']['result']['placeOfIssue'];
        let expiryDate = response['response']['result']['expiryDate'];
        let issueDate = response['response']['result']['issueDate'];
        this.passportExpiryDate = { 'year': parseInt(expiryDate.split("/")[2]), 'month': parseInt(expiryDate.split("/")[1]), 'day': parseInt(expiryDate.split("/")[0]) };
        this.passportIssueDate = { 'year': parseInt(issueDate.split("/")[2]), 'month': parseInt(issueDate.split("/")[1]), 'day': parseInt(issueDate.split("/")[0]) };
      } else {
        //this.toast.error('Please upload valid passport documents!');
      }
    }, error => {
      this.showLoader = false;
      // this.toast.error(error.error.message);
    });
  }

  getProfileList() {
    this.showLoader = true;
    this.updateProfileService.getProfileListAll().subscribe(resp => {
      this.showLoader = false;
      this.consumerDetail = resp.body;
      console.log("Consumer Details ------------- ",this.consumerDetail);
      this.paxId = this.consumerDetail?.paxResponse?.id;

        this.explorerActivationRequest.panNumber = this.consumerDetail?.paxResponse?.pan;
        this.profilePan = this.consumerDetail?.paxResponse?.pan;
        this.explorerActivationRequest.passportNumber =  this.consumerDetail?.paxResponse?.passportNumber;
        this.explorerActivationRequest.passportIssuePlace =  this.consumerDetail?.paxResponse?.passportIssuePlace;

        if (this.consumerDetail?.paxResponse?.passportIssueDate) {
          this.passportIssueDate = DateUtils.ngbDateStructDateConverter(moment(this.consumerDetail.paxResponse.passportIssueDate).format("YYYY-MM-DD"));
        }

        if (this.consumerDetail?.paxResponse?.passportExpiryDate) {
          this.passportExpiryDate = DateUtils.ngbDateStructDateConverter(moment(this.consumerDetail.paxResponse.passportExpiryDate).format("YYYY-MM-DD"));          
        }


      this.consumerDetail.paxResponse.paxDocuments.forEach(singleDoc => {
        console.log(JSON.stringify(singleDoc));
        if (singleDoc.type == "PANCARD") {
          this.panCardLink = singleDoc.location;
          let control = this.formStep2.get('panUpload');
          control.clearValidators();
          // control?.disable();
        } else if(singleDoc.type == "PASSPORT_FRONT_PAGE") {
          this.passportFrontSideLink = singleDoc.location;
          let control = this.formStep3.get('passportFrontPage');
          control.clearValidators();
          // control?.disable();
        } else if(singleDoc.type == "PASSPORT_ADDRESS_PAGE") {
          this.passportBackSideLink = singleDoc.location;        
          let control = this.formStep3.get('passportBackPage');
          control.clearValidators();     
          // control?.disable();                            
        }
      });


    }, error => {
      this.showLoader = false;
      this.toast.error(error.error.message);
    });
  }


  initiateVcip() {
    this.modalReference.close();
    console.log("PAN ----------------------------------------------- ",this.profilePan);
    if(!this.profilePan || this.profilePan == "") {
      this.modalReference = this.modalService.open(this.PANDetailModal, {centered: true,size: "md", backdrop: 'static', keyboard: false});
    } else {
      this.updateProfileService.getVCIPRedirectionURL().subscribe(
        (resp) => {
          this.showLoader = false;
          var vcipResponse = JSON.parse(JSON.stringify(resp.body));
          let vcipUrl = vcipResponse.mobileAutologinUrl;
          window.open(vcipUrl, "_blank");
        this.modalReference = this.modalService.open(this.cardActivationSuccess, {centered: true,size: "md", backdrop: 'static', keyboard: false});
        },
        (error) => {
          this.modalReference = this.modalService.open(this.cardActivationSuccess, {centered: true,size: "md", backdrop: 'static', keyboard: false});
          this.showLoader = false;
          this.toast.error(JSON.stringify(error.error.message));
        }
      );
    }

  }

  async getVCIPStatus() {
    this.updateProfileService.getVCIPStaus().subscribe((resp => {
      this.showLoader = false;
      this.resGetVcipStatus = resp.body;
      if (this.resGetVcipStatus.vcipStatus == 'PENDING' || this.resGetVcipStatus.vcipStatus == 'NOT_INITIATED' || this.resGetVcipStatus.vcipStatus == 'DRAFT') {
        this.vcipStatus = false;
      } else if(this.resGetVcipStatus.vcipStatus == 'ACCEPTED') {
        this.vcipStatus = true;
      }
    }), error => {
      this.toast.error(error.error.message);
    });
    return true;
  }

  proceedWithourVCIP() {
    this.modalReference.close();
    this.modalReference = this.modalService.open(this.cardActivationSuccess, {centered: true,size: "md", backdrop: 'static', keyboard: false});
  }

  closeSuccess() {
    this.modalReference.close();
    // this.router.navigate(["cards"]);
  }

  downloadUploadedDoc(doc) {
    if(doc == "PANCARD") {
      window.location.assign(this.panCardLink);
    } else if(doc == "PASSPORT_FORNT") {
      window.location.assign(this.passportFrontSideLink);
    } else if(doc == "PASSPORT_ADDRESS") {
      window.location.assign(this.passportBackSideLink);
    }
  }

  isFormValid() {
    if(this.currentForm.valid && this.steps.length) {

    }
  }
  validatePanAPI() {
    if (this.validatePanDetails()) {
      this.showLoader = true;
      let dateofBirth = DateUtils.getNgbDateStructToDatev2(
        this.updateProfileModel.dob
      );

      this.updateProfileService
        .validatePAN(
          this.updateProfileModel.pan,
          this.updateProfileModel.name,
          dateofBirth
        )
        .subscribe(
          async (resp) => {
            console.log(resp.body);
            var panResponse = JSON.parse(JSON.stringify(resp.body));
            this.showLoader = false;
            if (panResponse.panStatus == "E") {
              // && panResponse.fullName != "" && panResponse.dob != ""
              this.updatePAN();
            } else if (panResponse.panStatus != "E") {
              this.panVerificationErrMsg = "Please enter valid PAN";
              this.openErrorModal();
            } /* else if (panResponse.fullName == "") {
        this.panVerificationErrMsg = "Please enter Name as per PAN";
        this.openErrorModal();
      }
      else if (panResponse.dob == "") {
        this.panVerificationErrMsg = "Please enter valid Date of Birth";
        this.openErrorModal();
      } */
          },
          (error) => {
            this.showLoader = false;
            this.toast.error(error.error.message);
          }
        );
    }
  }

  updatePAN() {
    this.showLoader = true;
    this.updateProfileModel.mobile = this.consumerDetail.mobile;
    this.updateProfileModel.email = this.consumerDetail.email;
    let dateofBirth = DateUtils.getNgbDateStructToDate(
      this.updateProfileModel.dob
    );
    this.updateProfileModel.dob = dateofBirth;
    console.log("pax model>>>> ", JSON.stringify(this.updateProfileModel));
    this.updateProfileService
      .updateProfileDetails(this.paxId, this.updateProfileModel)
      .subscribe(
        async (resp) => {
          this.toast.success("Your PAN details are updated successfully!");

          this.showLoader = false;

          this.modalReference.close();
          this.modalReference = this.modalService.open(this.cardActivationSuccess, {centered: true,size: "md", backdrop: 'static', keyboard: false});
          this.initiateVcip();
        },
        (error) => {
          this.showLoader = false;
          if (error.status == 200) {
            this.initiateVcip();
            this.modalReference.close();
            this.modalReference = this.modalService.open(this.cardActivationSuccess, {centered: true,size: "md", backdrop: 'static', keyboard: false});            
            //if (this.isVCIPNow) {
              //this.initiateVcip();
            // }
          } else {
            this.toast.error("Something went wrong ! Please try again !");
          }
        }
      );
  }
  
  openErrorModal() {
    this.modalReference = this.modalService.open(this.errorModal, {
      centered: true,
      size: "sm",
    });
  }

  validatePanDetails() {
    if (!(this.updateProfileModel.pan != null)) {
      this.toast.error("Please enter your PAN");
      return false;
    }
    if (!this.validatePANNo(this.updateProfileModel.pan)) {
      this.toast.error("Please enter valid PAN");
      return false;
    }
    if (!(this.updateProfileModel.name != null)) {
      this.toast.error("Please enter name as per PAN");
      return false;
    }
    if (!this.isPANCBChecked) {
      this.toast.error("Please check the declaration of PAN");
      return false;
    }
    if (!(this.updateProfileModel.dob != null)) {
      this.toast.error("Please select your Date of Birth ");
      return false;
    }

    return true;
  }  

  validatePANNo(panNo) {
    const regex = /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$/;
    if (!regex.test(panNo)) {
      return false;
    } else {
      return true;
    }
  }  

  alphaNumberOnly(e) {
    // Accept only alpha numerics, not special characters
    var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }
    e.preventDefault();
    return false;
  }  

  getPanName() {
    this.updateProfileModel.pan = this.updateProfileModel.pan.toUpperCase();
    if (
      this.updateProfileModel.pan &&
      this.updateProfileModel.pan.length == 10 &&
      this.validatePANNo(this.updateProfileModel.pan)
    ) {
      this.showLoader = true;
      this.updateProfileService
        .getPANName(this.updateProfileModel.pan)
        .subscribe(
          async (resp) => {
            console.log(resp.body);
            var panResponse = JSON.parse(JSON.stringify(resp.body));
            this.showLoader = false;
            if (panResponse.panStatus == "E") {
              if (
                panResponse.fullName &&
                panResponse.fullName != "null" &&
                panResponse.fullName != ""
              ) {
                this.updateProfileModel.name = panResponse.fullName;
              } else {
                this.updateProfileModel.name = "";
              }

              if (
                panResponse.dob &&
                panResponse.dob != "null" &&
                panResponse.dob != ""
              ) {
                this.updateProfileModel.dob =
                  DateUtils.ngbDateStructDateConverter(panResponse.dob);
              }
            } else if (
              panResponse.flatPan.status ==
              "Record Not Found in ITD Database/Invalid PAN"
            ) {
              this.updateProfileModel.name = "";
              this.updateProfileModel.dob = "";
              this.toast.error("Invalid Pan");
            } /* else {
          this.toast.error(panResponse.flatPan.status);
        } */
          },
          (error) => {
            this.showLoader = false;
            this.updateProfileModel.name = "";
            // this.updateProfileModel.dob = '';
            this.toast.error(error.error.message);
          }
        );
    }
  }  


  closeOnPanModel() {
    this.modalReference.close();
    this.modalReference = this.modalService.open(this.cardActivationSuccess, {centered: true,size: "md", backdrop: 'static', keyboard: false});
  }

  parentCallbackForAddAddressForm(event: Event) {
    console.log("EVENT ------------------------------------ ", event);

  }

  showAddAddressModal(addAddressModal) {
    this.showAddAddressForm = true;
    this.addressActionBtnText = "Add";
    this.modalReference?.close();
    this.modalReference = this.modalService.open(addAddressModal, { centered: true,size: "md", backdrop: 'static', keyboard: false});
    /* setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300); */
  }

  pincodeCheck(type) {
    var pincode;

    if(type == 'NEW') {
      pincode = this.explorerActivationRequest.pinCode;
    } else {
      pincode = this.addAddressModel.postalCode;
    }

    if (pincode && pincode.toString().length == 6) {
      this.showLoader = true;
      this.addressService.verifyPincode(pincode).subscribe((pincodeResp) => {
        // console.log("PINCODE VERIFY", pincodeResp.body);
        let pincodeData = pincodeResp.body;
        this.isPincodeIsValid = true;
        this.isPincodeCheck = true;
        this.addAddressModel.city = undefined;
        this.explorerActivationRequest.city = undefined;
        this.cityItemList = pincodeData;
        if(this.cityItemList.length == 1) {
          if(type == 'NEW') {         
            this.explorerActivationRequest.city = this.cityItemList[0].city;
            this.explorerActivationRequest.state = this.cityItemList[0].state; 
          } else {
          this.addAddressModel.city = this.cityItemList[0].city;
          this.addAddressModel.state = this.cityItemList[0].state;      
          }

        }
        this.checkDeliveryAvailbleByPincode(pincode);
      }, error => {
        this.isPincodeCheck = true;
        this.isPincodeIsValid = false;
        this.showLoader = false;
      });
    } else {
        this.addAddressModel.city = undefined;
        this.addAddressModel.state = undefined;        
        this.explorerActivationRequest.city = undefined;
        this.explorerActivationRequest.state = undefined;                  
        this.cityItemList = [];
    }
  }

  checkDeliveryAvailbleByPincode(pincode) {
    if(pincode && pincode.toString().length == 6) {
      this.showLoader = false;
      this.addressService.isDeliveryAvailbleByPincode(pincode).subscribe((resPincodeData) => {
        // console.log("PINCODE DATA", resPincodeData);
        this.deliveryStatus = resPincodeData.body;
        this.isDeliveryStatusCheck = true;
      }, error => {
        this.isDeliveryStatusCheck = true;
        this.showLoader = false;
      });
    }
  }  

  setDefaultAddress(addressId: string) {

  }


  addAddress(data){
    if(this.addressActionBtnText == "Add") {
      if(data == true && this.isPincodeIsValid){
        this.showLoader = true;
        //this.addAddressModel.isDefault = this.addAddressModel.isDefault;
        this.addAddressModel.country = 'INDIA';
        

        this.addressService.addXplorerCardAddress(this.addAddressModel).subscribe((resp => {
          this.showLoader = false;
          this.toast.success("Address added successfully !");
          this.addAddressModel = new AddAddressModel();
          this.modalReference?.close();
          this.getXplorerUserAddress();
        }),error=>{
          this.showLoader = false;
          this.toast.error(error.error.message);
        });
      }    
    } else {



        this.addressService.udpateXplorerCardAddress(this.addAddressModel, this.addressIdForUpdate).subscribe((resp => {
          this.showLoader = false;
          this.toast.success("Address update successfully !");
          this.modalReference?.close();
          this.getXplorerUserAddress();
          this.addAddressModel = new AddAddressModel();
        }),error=>{
          this.showLoader = false;
          this.toast.error(error.error.message);
        });      
    }
  }  

  proceedForCardPurchase() {

    console.log("PROCEED FOR CARD PURCHASE  --------------------------- ", this.issuanceForm.value);
    let issuanceFormValues = this.issuanceForm.value;

    console.log(this.issuanceForm);

    if((!this.isNewCustomer && this.issuanceForm.valid) || this.isNewCustomer) {

    if(this.formSubmissionAddressId != "" || this.isNewCustomer) {
      if(this.consumerExistSubTerms || this.isNewCustomer) {
        if(this.isNewCustomer) {

        //3 STEP OBJECT
        this.explorerCardIssuanceRequest = new ExplorerCardIssuanceRequest();
        this.explorerCardIssuanceRequest.firstName = this.explorerActivationRequest.firstName;
        this.explorerCardIssuanceRequest.lastName = this.explorerActivationRequest.lastName;
        this.explorerCardIssuanceRequest.panNumber = this.formStep2.get("panNumber")?.value;    

        this.explorerCardIssuanceRequest.mobile = this.customerMoblieNo;
        this.explorerCardIssuanceRequest.email = this.custoemrEmailid;    

        this.explorerCardIssuanceRequest.passport = this.formStep3.get("passportNumber")?.value;
        this.explorerCardIssuanceRequest.passportIssueDate = DateUtils.getNgbDateStructToDate(this.formStep3.get("passportIssueDate")?.value);    
        this.explorerCardIssuanceRequest.passportExpiryDate = DateUtils.getNgbDateStructToDate(this.formStep3.get("passportExpiryDate")?.value);    
        this.explorerCardIssuanceRequest.passportIssuePlace = this.formStep3.get("passportIssuePlace")?.value;    



        this.explorerCardIssuanceRequest.dateOfBirth = DateUtils.getNgbDateStructToDate(this.formStep2.get("dob")?.value);
        this.explorerCardIssuanceRequest.preferredNameOnCard = this.formStep4.get("preferredNameOnCard")?.value;    
        this.explorerCardIssuanceRequest.addressId = this.newAddressId;

        } else {
              // this.explorerCardIssuanceRequest.firstName = 

          this.explorerCardIssuanceRequest.firstName = this.issuanceForm.get("firstName")?.value;
          this.explorerCardIssuanceRequest.lastName = this.issuanceForm.get("lastName")?.value;
          this.explorerCardIssuanceRequest.mobile = this.issuanceForm.get("mobileNumber")?.value;
          this.explorerCardIssuanceRequest.email = this.issuanceForm.get("emailId")?.value;    
          this.explorerCardIssuanceRequest.dateOfBirth = DateUtils.getNgbDateStructToDate(this.issuanceForm.get("dob")?.value);
          this.explorerCardIssuanceRequest.preferredNameOnCard = this.issuanceForm.get("preferredNameOnCard")?.value;    
          this.explorerCardIssuanceRequest.addressId = this.formSubmissionAddressId;
        }

        sessionStorage.setItem(ConstantsKey.XPLORER_SELECTED_ADDRESS, this.explorerCardIssuanceRequest.addressId);

        this.saveIssuanceForm(this.explorerCardIssuanceRequest);
       
      } else {
        this.toast.error("Please accept before proceed");        
      }
    } else {
      this.toast.error("Please select Address");
    }
      
    } else {
      this.toast.error("Plese enter all necessary field!");      
    }

  }


  getConsumerDetails() {

    this.updateProfileService.fetchCustomerDetails().subscribe(resp => {

      let respObj:any = resp.body;
      console.log("RESP ==================== ", respObj);   
      this.issuanceForm.patchValue({
        firstName: respObj?.firstName,
        lastName: respObj?.lastName,
        mobileNumber: respObj?.mobile,
        emailId: respObj?.email,
        preferredNameOnCard: respObj?.preferredNameOnCard
      });

      ['firstName', 'lastName', 'mobileNumber', 'emailId'].forEach(controlName => {
        const control = this.issuanceForm.get(controlName);
        if (control?.value) {
          control.disable();
        } else {
          control?.enable();
        }
      });

      this.isNewCustomer = respObj?.newConsumer;

      this.customerMoblieNo = respObj?.mobile;
      this.custoemrEmailid = respObj?.email;

      if(respObj?.dateOfBirth && respObj?.dateOfBirth != "") {
        let consDOB = DateUtils.ngbDateStructDateConverter(respObj?.dateOfBirth);
        this.issuanceForm.patchValue({
          dob: {
            day: consDOB.day,
            month: consDOB.month,
            year: consDOB.year,
          }
        });
        this.issuanceForm.get('dob')?.disable();
      } else {
        this.issuanceForm.get('dob')?.enable();
      }

    }, err => {

    });


  }


  getXplorerUserAddress() {
    this.addressService.getXplorerCardAddress().subscribe(resp => {
      this.consumerAddressList = resp.body;
      console.log("this.consumerAddressList ------------------ ", this.consumerAddressList);
      for(let i= 0; i < this.consumerAddressList.length; i++) {
        if(this.consumerAddressList[i].default) {
          this.formSubmissionAddressId = this.consumerAddressList[i]?.id
        } 
      }
    }, err => {

    });
  }

  updateAddress(addressObj: any, addAddressModal) {

    this.modalReference?.close();

    this.addressActionBtnText = "UDPATE";
    this.addAddressModel.locationType = addressObj.locationType;
    this.addAddressModel.postalCode = addressObj.postalCode;
    this.addAddressModel.address = addressObj.address;
    this.addAddressModel.city = addressObj.city;
    this.addAddressModel.state = addressObj.state;
    this.addressIdForUpdate = addressObj.id;
    this.addAddressModel.id = addressObj.id;
    this.addAddressModel.isDefault = addressObj.default;
    this.addAddressModel.country = addressObj.country;    
    this.modalReference = this.modalService.open(addAddressModal, { centered: true,size: "md", backdrop: 'static', keyboard: false});


  }

  deleteAddress(addressObj: any) {
    this.addressService.deleteXplorerCardAddress(addressObj.id).subscribe(resp => {
      let respMsg:any = resp.body;
      this.toast.success(respMsg.msg);
      this.getXplorerUserAddress();      
    }, err => {
      this.toast.error(err.error.message);
      this.getXplorerUserAddress();      
    });
  }  

  saveIssuanceForm(reqObj: any) {


    console.log("SAVE ISSUANCE FORM", reqObj);
    this.addressService.xplorerCardUpdateCustomerDetails(reqObj).subscribe(resp => {
      console.log("TEST --------------- OBJECT ", reqObj);
      let selectedCard = this.cards.filter(card => card.cardVendor == "WSFXXPMCC");
      if(selectedCard.length > 0) {
        sessionStorage.setItem(ConstantsKey.WSFX_SELECTED_CARDS, JSON.stringify(selectedCard[0]));
      }
      sessionStorage.setItem(ConstantsKey.IS_XPLORER_PURCHASE, "YES");
      this.router.navigate(["view-cart"]);    

    }, err => {
      this.toast.error(err.error.message);

    });


  }

  selectAddress(addressId: string) {
    this.formSubmissionAddressId = addressId;
    console.log("this.formSubmissionAddressId ------------------ ", this.formSubmissionAddressId);
  }
  
  checkTermsCheckBox() {
    this.consumerExistSubTerms = !this.consumerExistSubTerms;
  }

}
